import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyFormOptions, FormlyModule } from '@ngx-formly/core';
import { MessageService } from 'primeng/api';
import { VersioningSelectComponent } from '../../../../components/common/versioning-select/versioning-select.component';
import { editMappingTemplate } from '../../../../core/generic-templates/formly-form-templates';
import { ToasterService } from '../../../../core/services/toaster-service';
import { MessageEnum } from '../../../../core/utils/message.enum';

@Component({
  selector: 'app-testcase-mapping-edit',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
    FormlyBootstrapModule,
    VersioningSelectComponent
  ],
  templateUrl: './testcase-mapping-edit.component.html',
  styleUrl: './testcase-mapping-edit.component.scss'
})
export class TestcaseMappingEditComponent {

  @Output() onEventEmit = new EventEmitter();

  @Input()
  model: any;

  private messageService = inject(MessageService); 
  isProcessing = false;
  fields: any = {};
  form = {
    formDescription: new FormGroup({}),
    formGitHubLink: new FormGroup({}),
    formSpecifications: new FormGroup({})
  };
  options: FormlyFormOptions = {};

  versioning: any = {
    selectedVersion: null,
    // Dummy data
    versions: [
      {
        label: 'Test Pack Version 1.0',
        value: 'Test Pack Version 1.0'
      },
      {
        label: 'Test Pack Version 2.0',
        value: 'Test Pack Version 2.0'
      }
    ]
  };

  outputActions: any = [
    {
      name: 'Update Mappings',
      key: 'updateMappings'
    },
    {
      name: 'Preview Mappings',
      key: 'previewMappings'
    },
    {
      name: 'Impacted TestCases',
      key: 'impactedTestCases',
      notifyParent: true,
      hideSpinner: true
    }
  ];

  constructor(private readonly toaster: ToasterService) { }

  ngOnInit() {
    this.fields = editMappingTemplate;
  }

  triggerAction(item: any) {
    item.isLoading = true;
    if(!item.hideSpinner) {
      setTimeout(() => {
        item.isLoading = false;
      }, 3000);
    }
    if(item.notifyParent) {
      this.onEventEmit.emit(
        {
          type: item.key
        }
      );
    }
  }

  onProceed() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
      this.toaster.pop({ type: 'success', text: MessageEnum.TEST_CASE_UPDATED_SUCCESS });
    }, 3000);
  }

}
